import styled from 'styled-components/macro';

const $Form = styled.form`
  display: inherit;
  flex-flow: inherit;
`;

export default $Form;
